export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: number; output: number; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type AuthTokensModel = {
  __typename?: 'AuthTokensModel';
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CollectionModel = HierarchyNodeModel & {
  __typename?: 'CollectionModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  typeId: Scalars['ID']['output'];
};

export type CollectionSearchResult = {
  __typename?: 'CollectionSearchResult';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CollectionTabModel = {
  __typename?: 'CollectionTabModel';
  collectionId: Scalars['String']['output'];
  filterTree: Array<FilterNodeModel>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
};

export type CollectionTreeModel = {
  __typename?: 'CollectionTreeModel';
  nodes: Array<HierarchyNodeModel>;
};

export type CollectionViewColumnModel = {
  __typename?: 'CollectionViewColumnModel';
  isVisible: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  propertyDefinitionId: Scalars['ID']['output'];
  widthWeight: Scalars['Float']['output'];
};

export type CollectionViewSettingsModel = {
  __typename?: 'CollectionViewSettingsModel';
  collectionId: Scalars['ID']['output'];
  columns: Array<CollectionViewColumnModel>;
  groupByColumnId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
};

export type CreateCollectionInput = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  typeId: Scalars['ID']['input'];
};

export type CreateCollectionTabInput = {
  collectionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateFolderInput = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateObjectInput = {
  propertyValues: Array<PropertyValueInput>;
  typeId: Scalars['ID']['input'];
};

export type CreateObjectTypeInput = {
  name: Scalars['String']['input'];
  propertyDefInputs: Array<CreatePropertyDefinitionInput>;
  spaceId: Scalars['ID']['input'];
};

export type CreatePropertyDefinitionInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreatePropertyOptionInput = {
  value: Scalars['String']['input'];
};

export type CreateSpaceInput = {
  name: Scalars['String']['input'];
};

export type DeleteCollectionTabInput = {
  id: Scalars['ID']['input'];
};

export type DeleteObjectInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSpaceInput = {
  id: Scalars['ID']['input'];
};

export enum FilterLogicalOperator {
  And = 'And',
  Or = 'Or'
}

export type FilterNodeInput = {
  clientId: Scalars['String']['input'];
  logicalOperator?: InputMaybe<FilterLogicalOperator>;
  operator?: InputMaybe<FilterOperator>;
  parentClientId?: InputMaybe<Scalars['String']['input']>;
  propertyDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterNodeModel = {
  __typename?: 'FilterNodeModel';
  id: Scalars['ID']['output'];
  logicalOperator: Maybe<FilterLogicalOperator>;
  operator: Maybe<FilterOperator>;
  parentId: Maybe<Scalars['ID']['output']>;
  propertyDefinitionId: Maybe<Scalars['ID']['output']>;
  value: Maybe<Scalars['String']['output']>;
  values: Maybe<Array<Scalars['String']['output']>>;
};

export enum FilterOperator {
  AllIn = 'AllIn',
  Contains = 'Contains',
  EndsWith = 'EndsWith',
  Eq = 'Eq',
  Gt = 'Gt',
  Gte = 'Gte',
  In = 'In',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  Lt = 'Lt',
  Lte = 'Lte',
  Neq = 'Neq',
  NotContains = 'NotContains',
  NotIn = 'NotIn',
  StartsWith = 'StartsWith'
}

export type FolderModel = HierarchyNodeModel & {
  __typename?: 'FolderModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  spaceId: Scalars['ID']['output'];
};

export type FolderSearchResult = {
  __typename?: 'FolderSearchResult';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HierarchyNodeModel = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCollection: CollectionModel;
  createCollectionTab: CollectionTabModel;
  createFolder: FolderModel;
  createObject: ObjectModel;
  createObjectType: ObjectTypeModel;
  createSpace: SpaceModel;
  deleteCollection: Scalars['Boolean']['output'];
  deleteCollectionTab: Scalars['Boolean']['output'];
  deleteFolder: Scalars['Boolean']['output'];
  deleteObject: Scalars['Boolean']['output'];
  deleteObjectType: Scalars['Boolean']['output'];
  deleteSpace: Scalars['Boolean']['output'];
  login: AuthTokensModel;
  markTutorialShown: UserModel;
  refresh: AuthTokensModel;
  register: AuthTokensModel;
  reseedUser: Scalars['Boolean']['output'];
  resetUser: Scalars['Boolean']['output'];
  seedUser: Scalars['Boolean']['output'];
  updateCollection: CollectionModel;
  updateCollectionTab: CollectionTabModel;
  updateCollectionViewSettings: CollectionViewSettingsModel;
  updateFolder: FolderModel;
  updateObject: Scalars['Boolean']['output'];
  updateObjectType: ObjectTypeModel;
  updatePropertyDefinition: PropertyDefinitionModel;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCollectionTabArgs = {
  input: CreateCollectionTabInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateObjectArgs = {
  input: CreateObjectInput;
};


export type MutationCreateObjectTypeArgs = {
  input: CreateObjectTypeInput;
};


export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput;
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionTabArgs = {
  input: DeleteCollectionTabInput;
};


export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteObjectArgs = {
  input: DeleteObjectInput;
};


export type MutationDeleteObjectTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSpaceArgs = {
  input: DeleteSpaceInput;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMarkTutorialShownArgs = {
  tutorialId: Scalars['String']['input'];
};


export type MutationRefreshArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateCollectionTabArgs = {
  input: UpdateCollectionTabInput;
};


export type MutationUpdateCollectionViewSettingsArgs = {
  input: UpdateCollectionViewSettingsInput;
};


export type MutationUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type MutationUpdateObjectArgs = {
  input: UpdateObjectInput;
};


export type MutationUpdateObjectTypeArgs = {
  input: UpdateObjectTypeInput;
};


export type MutationUpdatePropertyDefinitionArgs = {
  input: UpdatePropertyDefinitionInput;
};

export type ObjectModel = {
  __typename?: 'ObjectModel';
  id: Scalars['ID']['output'];
  propertyValues: Array<PropertyModel>;
  typeId: Scalars['ID']['output'];
};

export type ObjectQueryResultModel = {
  __typename?: 'ObjectQueryResultModel';
  typeIdToObjects: Scalars['JSON']['output'];
};

export type ObjectSearchResult = {
  __typename?: 'ObjectSearchResult';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  typeId: Scalars['Int']['output'];
};

export type ObjectTypeModel = {
  __typename?: 'ObjectTypeModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  propertyDefinitions: Array<PropertyDefinitionModel>;
  space: Maybe<SpaceModel>;
  spaceId: Scalars['Float']['output'];
};

export type PropertyDefinitionModel = {
  __typename?: 'PropertyDefinitionModel';
  id: Scalars['ID']['output'];
  isMeta: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  objectTypeId: Scalars['Float']['output'];
  options: Maybe<Array<PropertyOptionModel>>;
  type: Scalars['String']['output'];
};

export type PropertyModel = {
  __typename?: 'PropertyModel';
  definitionId: Scalars['Int']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type PropertyOptionModel = {
  __typename?: 'PropertyOptionModel';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type PropertyValueInput = {
  definitionId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  collection: Maybe<CollectionModel>;
  collectionTabs: Maybe<Array<CollectionTabModel>>;
  collectionViewSettings: CollectionViewSettingsModel;
  collectionsTree: CollectionTreeModel;
  folder: Maybe<FolderModel>;
  object: Maybe<ObjectModel>;
  objectType: Maybe<ObjectTypeModel>;
  objectTypes: Array<ObjectTypeModel>;
  objectsOfTypes: Maybe<ObjectQueryResultModel>;
  search: Array<SearchResult>;
  spaces: Array<SpaceModel>;
  user: UserModel;
};


export type QueryCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionTabsArgs = {
  collectionId: Scalars['ID']['input'];
};


export type QueryCollectionViewSettingsArgs = {
  collectionId: Scalars['ID']['input'];
};


export type QueryCollectionsTreeArgs = {
  spaceId: Scalars['ID']['input'];
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObjectTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObjectTypesArgs = {
  spaceId: Scalars['ID']['input'];
};


export type QueryObjectsOfTypesArgs = {
  typeIds: Array<Scalars['ID']['input']>;
};


export type QuerySearchArgs = {
  input: SearchInput;
};

export type SearchInput = {
  /** Limit object results to these collections */
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query: Scalars['String']['input'];
  scope?: InputMaybe<SearchScope>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  collection: Maybe<CollectionSearchResult>;
  folder: Maybe<FolderSearchResult>;
  object: Maybe<ObjectSearchResult>;
  score: Scalars['Float']['output'];
};

export enum SearchScope {
  All = 'All',
  Collections = 'Collections',
  Objects = 'Objects'
}

export type SpaceModel = {
  __typename?: 'SpaceModel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UpdateCollectionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCollectionTabInput = {
  filterTree?: InputMaybe<Array<FilterNodeInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollectionViewColumnInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  propertyDefinitionId: Scalars['ID']['input'];
  widthWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCollectionViewSettingsInput = {
  columns?: InputMaybe<Array<UpdateCollectionViewColumnInput>>;
  groupByColumnId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateFolderInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateObjectInput = {
  id: Scalars['ID']['input'];
  propertyValues: Array<PropertyValueInput>;
};

export type UpdateObjectTypeInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  propertiesToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  propertyCreateInputs?: InputMaybe<Array<CreatePropertyDefinitionInput>>;
};

export type UpdatePropertyDefinitionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<UpdatePropertyOptionsInput>;
};

export type UpdatePropertyOptionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePropertyOptionsInput = {
  createInputs?: InputMaybe<Array<CreatePropertyOptionInput>>;
  toDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  updates?: InputMaybe<Array<UpdatePropertyOptionInput>>;
};

export type UserModel = {
  __typename?: 'UserModel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shownTutorials: Array<Scalars['String']['output']>;
};
